module.exports = __webpack_public_path__ + "static/property4-be645c9a2408c43f8301cd424c5d91b3.png";